module.exports = __webpack_public_path__ + "media/images/icon__calendar@3x-7ae4a6f958e3b698394bf6d32ae98d8b.png";